import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'mkmReport',
    label: 'MKM Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
